import './Hero.scss'
import Background from '../../../assets/walpaper3.jpg'
import { Link } from 'react-router-dom'

const Hero = () => {
  return (
    <div className='hero-section'>
        <img src={Background} 
            alt="background" 
            className='background-image' 
        />
      
      {/* Hero text */}
      <div className="hero-text-container">
        <div className="my-texts">
            <span className='hero-text'>We are here to Serve You and Your Family!</span>
            <h1 className='hero-type-heading'>Jephte Houses Group Ltd.</h1>
            <span className='hero-text'>Serving Rwanda and the rest of the world!</span>
            <Link to="explore" className="properties">Browse Properties</Link>
        </div>
      </div>
    </div>
  )
}

export default Hero
